import { styled } from '@mui/system';

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  flex: 1,
  justifyContent: 'space-around',
  alignItems: 'stretch'
}));

export const ColumnLeft = styled('div')<{ isShort: boolean; isMedium: boolean }>(({ isShort, isMedium }) => ({
  flexBasis: '80px',
  flexGrow: 0,
  flexShrink: 0,
  backgroundColor: '#004763',
  ...(isShort && {
    flexBasis: '50px'
  }),
  ...(isMedium && {
    flexBasis: '60px'
  })
}));

export const ColumnCenter = styled('div')({
  flexBasis: 'auto',
  width: '100%',
  position: 'relative'
});
